import { createSlice, configureStore } from "@reduxjs/toolkit";

/*
 * Slices removed as dead code (no useSelector read, no dispatch anywhere):
 *   secTab, menu, products, gif, contractDetails, userGeo
 * `phone` and `contract` are kept: they are still dispatched to from the
 * user/contract flows even though nothing reads them yet.
 */

const mainTabSlice = createSlice({
  name: "mainTab",
  initialState: { mainTab: "افراد" },
  reducers: {
    update(state, action) {
      state.mainTab = action.payload;
    },
  },
});

const phoneSlice = createSlice({
  name: "phone",
  initialState: { phone: "" },
  reducers: {
    update(state, action) {
      state.phone = action.payload;
    },
  },
});

const UserDataSlice = createSlice({
  name: "user",
  initialState: {
    activationStatus: "",
    avatar: "",
    email: "",
    id: "",
    isEligible: "",
    name: "",
    nationalId: "",
    refContact: "",
    secondPhone: "",
    wallet: "",
  },
  reducers: {
    update: (state, action) => {
      state[action.payload.key] = action.payload.val;
    },
  },
});

const ContractSlice = createSlice({
  name: "contract",
  initialState: {
    Details: [],
  },
  reducers: {
    update: (state, action) => {
      state[action.payload.key] = action.payload.val;
    },
  },
});

const localeSlice = createSlice({
  name: "lang",
  initialState: {
    locale: "",
  },
  reducers: {
    update: (state, action) => {
      state.locale = action.payload;
    },
  },
});

const optionSlice = createSlice({
  name: "option",
  initialState: {
    id: 1,
  },
  reducers: {
    setOptionId: (state, action) => {
      state.id = action.payload;
    },
  },
});

const store = configureStore({
  reducer: {
    mainTab: mainTabSlice.reducer,
    phone: phoneSlice.reducer,
    user: UserDataSlice.reducer,
    contract: ContractSlice.reducer,
    lang: localeSlice.reducer,
    option: optionSlice.reducer,
  },
});

export const mainTabActions = mainTabSlice.actions;
export const phoneActions = phoneSlice.actions;
export const userAction = UserDataSlice.actions;
export const ContractAction = ContractSlice.actions;
export const localAction = localeSlice.actions;
export const { setOptionId } = optionSlice.actions;
export default store;
